import Vue from 'vue'
import App from './App'

import Vuex from 'vuex'
import store from './store'
Vue.use(Vuex)

//vue plugins
import vuePlugins from './utils/vuePlugins'
//vue extend
import vueExtend from './utils/vueExtend'
//vue route
import router from './router'

import fetch from './utils/fetch'

import { Base64 } from 'js-base64';
Vue.use(Base64)

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js